export default "__VITE_ASSET__3naBpyUA__"